import { AdditionalItems, IAdditionalItems } from './AdditionalItems';

export const MandatoryAdditionalItems = (props: IAdditionalItems) => {
  return <AdditionalItems {...props} isMandatory />;
};
